<script setup lang="ts">
// A collection's cover (HRTH-164.6), from wherever coverOf found one, or a glyph for its type.
import type { Cover } from '../lib/collections'
import type { OpenEntry } from '../lib/libraryPlay'
import EntryImage from './EntryImage.vue'

defineProps<{ cover: Cover<OpenEntry>; glyph: string }>()
</script>

<template>
  <span class="field-grid flex h-full w-full items-center justify-center overflow-hidden text-text-muted">
    <EntryImage v-if="cover?.from === 'record'" :key="cover.record.entry.id + (cover.record.meta.blobs.art?.key ?? '')" :entry="cover.record" use="art">
      <span class="mono text-2xl">{{ glyph }}</span>
    </EntryImage>
    <EntryImage v-else-if="cover" :key="cover.file.entry.id" :entry="cover.file" :use="cover.from === 'art' ? 'art' : 'thumb'">
      <span class="mono text-2xl">{{ glyph }}</span>
    </EntryImage>
    <span v-else class="mono text-2xl">{{ glyph }}</span>
  </span>
</template>
